/* tslint:disable */
/* eslint-disable */
/**
 * Armasuisse Dashboard Web Application API
 * API definitions for Armasuisse Dashboard Web Application
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PhaseType } from '../models';
// @ts-ignore
import { ProblemDetails } from '../models';
// @ts-ignore
import { ProjectPhaseBase } from '../models';
// @ts-ignore
import { ProjectPhaseBaseResponse } from '../models';
/**
 * ProjectPhasesApi - axios parameter creator
 * @export
 */
export const ProjectPhasesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates new Project Phase and returns newly created Project Phase.
         * @summary Creates new Project Phase.
         * @param {ProjectPhaseBase} [projectPhaseBase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProjectPhase: async (projectPhaseBase?: ProjectPhaseBase, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ProjectPhases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectPhaseBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete Project Phase.
         * @summary Delete Project Phase.
         * @param {number} entityID Project Phase identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjectPhase: async (entityID: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityID' is not null or undefined
            assertParamExists('deleteProjectPhase', 'entityID', entityID)
            const localVarPath = `/ProjectPhases/{entityID}`
                .replace(`{${"entityID"}}`, encodeURIComponent(String(entityID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the Project Phase.
         * @summary Get Project Phase details.
         * @param {number} entityID Project Phase identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectPhaseDetails: async (entityID: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityID' is not null or undefined
            assertParamExists('getProjectPhaseDetails', 'entityID', entityID)
            const localVarPath = `/ProjectPhases/{entityID}`
                .replace(`{${"entityID"}}`, encodeURIComponent(String(entityID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of Project Phases.
         * @summary Get filtered list of Project Phases.
         * @param {PhaseType} [type] Phase type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectPhaseList: async (type?: PhaseType, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ProjectPhases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (type !== undefined) {
                localVarQueryParameter['Type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update Project Phase and returns the modified Project Phase.
         * @summary Edit Project Phase.
         * @param {number} entityID Project Phase identifier
         * @param {ProjectPhaseBase} [projectPhaseBase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProjectPhase: async (entityID: number, projectPhaseBase?: ProjectPhaseBase, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityID' is not null or undefined
            assertParamExists('updateProjectPhase', 'entityID', entityID)
            const localVarPath = `/ProjectPhases/{entityID}`
                .replace(`{${"entityID"}}`, encodeURIComponent(String(entityID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectPhaseBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectPhasesApi - functional programming interface
 * @export
 */
export const ProjectPhasesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectPhasesApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates new Project Phase and returns newly created Project Phase.
         * @summary Creates new Project Phase.
         * @param {ProjectPhaseBase} [projectPhaseBase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addProjectPhase(projectPhaseBase?: ProjectPhaseBase, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectPhaseBaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addProjectPhase(projectPhaseBase, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete Project Phase.
         * @summary Delete Project Phase.
         * @param {number} entityID Project Phase identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProjectPhase(entityID: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProjectPhase(entityID, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the Project Phase.
         * @summary Get Project Phase details.
         * @param {number} entityID Project Phase identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectPhaseDetails(entityID: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectPhaseBaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectPhaseDetails(entityID, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list of Project Phases.
         * @summary Get filtered list of Project Phases.
         * @param {PhaseType} [type] Phase type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectPhaseList(type?: PhaseType, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectPhaseBaseResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectPhaseList(type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update Project Phase and returns the modified Project Phase.
         * @summary Edit Project Phase.
         * @param {number} entityID Project Phase identifier
         * @param {ProjectPhaseBase} [projectPhaseBase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProjectPhase(entityID: number, projectPhaseBase?: ProjectPhaseBase, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectPhaseBaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProjectPhase(entityID, projectPhaseBase, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProjectPhasesApi - factory interface
 * @export
 */
export const ProjectPhasesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectPhasesApiFp(configuration)
    return {
        /**
         * Creates new Project Phase and returns newly created Project Phase.
         * @summary Creates new Project Phase.
         * @param {ProjectPhaseBase} [projectPhaseBase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProjectPhase(projectPhaseBase?: ProjectPhaseBase, options?: any): AxiosPromise<ProjectPhaseBaseResponse> {
            return localVarFp.addProjectPhase(projectPhaseBase, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete Project Phase.
         * @summary Delete Project Phase.
         * @param {number} entityID Project Phase identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjectPhase(entityID: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteProjectPhase(entityID, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the Project Phase.
         * @summary Get Project Phase details.
         * @param {number} entityID Project Phase identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectPhaseDetails(entityID: number, options?: any): AxiosPromise<ProjectPhaseBaseResponse> {
            return localVarFp.getProjectPhaseDetails(entityID, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of Project Phases.
         * @summary Get filtered list of Project Phases.
         * @param {PhaseType} [type] Phase type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectPhaseList(type?: PhaseType, options?: any): AxiosPromise<Array<ProjectPhaseBaseResponse>> {
            return localVarFp.getProjectPhaseList(type, options).then((request) => request(axios, basePath));
        },
        /**
         * Update Project Phase and returns the modified Project Phase.
         * @summary Edit Project Phase.
         * @param {number} entityID Project Phase identifier
         * @param {ProjectPhaseBase} [projectPhaseBase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProjectPhase(entityID: number, projectPhaseBase?: ProjectPhaseBase, options?: any): AxiosPromise<ProjectPhaseBaseResponse> {
            return localVarFp.updateProjectPhase(entityID, projectPhaseBase, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProjectPhasesApi - object-oriented interface
 * @export
 * @class ProjectPhasesApi
 * @extends {BaseAPI}
 */
export class ProjectPhasesApi extends BaseAPI {
    /**
     * Creates new Project Phase and returns newly created Project Phase.
     * @summary Creates new Project Phase.
     * @param {ProjectPhaseBase} [projectPhaseBase] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectPhasesApi
     */
    public addProjectPhase(projectPhaseBase?: ProjectPhaseBase, options?: AxiosRequestConfig) {
        return ProjectPhasesApiFp(this.configuration).addProjectPhase(projectPhaseBase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete Project Phase.
     * @summary Delete Project Phase.
     * @param {number} entityID Project Phase identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectPhasesApi
     */
    public deleteProjectPhase(entityID: number, options?: AxiosRequestConfig) {
        return ProjectPhasesApiFp(this.configuration).deleteProjectPhase(entityID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the Project Phase.
     * @summary Get Project Phase details.
     * @param {number} entityID Project Phase identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectPhasesApi
     */
    public getProjectPhaseDetails(entityID: number, options?: AxiosRequestConfig) {
        return ProjectPhasesApiFp(this.configuration).getProjectPhaseDetails(entityID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of Project Phases.
     * @summary Get filtered list of Project Phases.
     * @param {PhaseType} [type] Phase type.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectPhasesApi
     */
    public getProjectPhaseList(type?: PhaseType, options?: AxiosRequestConfig) {
        return ProjectPhasesApiFp(this.configuration).getProjectPhaseList(type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update Project Phase and returns the modified Project Phase.
     * @summary Edit Project Phase.
     * @param {number} entityID Project Phase identifier
     * @param {ProjectPhaseBase} [projectPhaseBase] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectPhasesApi
     */
    public updateProjectPhase(entityID: number, projectPhaseBase?: ProjectPhaseBase, options?: AxiosRequestConfig) {
        return ProjectPhasesApiFp(this.configuration).updateProjectPhase(entityID, projectPhaseBase, options).then((request) => request(this.axios, this.basePath));
    }
}
